var ItemState = {
	items: {},

	init: function() {

	},

	setState: function(item, s) {
		ItemState.items[item.id] = {'state': s};
	},

	canSpawn: function(item) {
		if (ItemState.items[item.id] == undefined) return true;
		return false;
	},

	state: function(c) {
		return ItemState.items[item.id].state;
	},

	resetStates: function(q) {
		var nc = [];
		var tmp = {};

		for(var c in ItemState.items) {
			var col = ItemState.items[c];
			if (col.collection_id != q.id) {
				nc[c] = col;
			}
		}

		Equipment.collectibles = nc;		
	}

}

PluginManager.add(ItemState);